// extracted by mini-css-extract-plugin
module.exports = {"container":"QuizFooter_container__VQ6IS"};